import BaseAPIService from '../base/base-api-service';
import ProductModel from 'src/model/product.model';
import env from 'src/shared/env';

interface IWPACFProduct {
  id: number;
  acf: {
    name: string;
    description: string;
    price: number;
    link: string;
    visible: string;
    image: {
      url: string;
    };
  };
}

class FeaturedProductsService extends BaseAPIService<ProductModel> {
  private wpBaseURL: string = env.REACT_APP_BASE_WORDPRESS_URL;
  public endpoint: string = 'wp-json/acf/v3/featuredProducts?page=1&per_page=100';

  constructor() {
    super(ProductModel);
  }

  public getProducts(): Promise<ProductModel[]> {
    return this.doRequest({
      url: this.wpBaseURL + this.endpoint,
      method: 'get'
    })
      .then(result => result.data)
      .then((result: IWPACFProduct[]) => {
        return this.castProducts(result);
      });
  }

  private castProducts(wpProducts: IWPACFProduct[]): ProductModel[] {
    const products: ProductModel[] = wpProducts.map(prod => {
      const product = new ProductModel();
      product.productNumber = prod.acf.name;
      product.description = prod.acf.description;
      product.partnerPrice = prod.acf.price;
      product.retailPrice = prod.acf.price;
      product.imageUrls = [prod.acf.image.url];
      return product;
    });
    return products;
  }
}

const featuredProductsServiceInstance = new FeaturedProductsService();
Object.freeze(featuredProductsServiceInstance);

export default featuredProductsServiceInstance;
